module.exports = __webpack_public_path__ + "static/img/sjzm_6.e64e839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjzm_6.jpg
// module id = +QmP
// module chunks = 1